import { ICKField } from '@/interfaces/interfaces';
import { StateCreator } from 'zustand';
import { WordEditorStoreState } from '../word-editor.store';

export interface WordEditorStoreKey {
  tempFields: ICKField[];
  selectedFields: ICKField[];
  previewFields: ICKField[];
}

export type WordEditorStoreKeyType = keyof WordEditorStoreKey;

export interface WordEditorSlice extends WordEditorStoreKey {
  // This is taken as array as in CK Editor multiple tags/fields can be selected at once

  actions: {
    setTempFields: (tempFields: ICKField[]) => void;
    setSelectedFields: (selectedFields: ICKField[]) => void;

    storeKeySetter: (key: WordEditorStoreKeyType, value: any) => void;
    getKey: (key: WordEditorStoreKeyType) => any;
    // updateCkFields: (
    //   field: ICKField,
    //   mode: 'add' | 'update' | 'delete',
    // ) => void;
  };
}

const initialState = {
  tempFields: [],
  selectedFields: [],
  previewFields: [],
};

export const createWordEditorSlice: StateCreator<
  WordEditorStoreState,
  [],
  [],
  WordEditorSlice
> = (set, get) => ({
  ...initialState,
  actions: {
    setTempFields: (tempFields: ICKField[]) => {
      set((state) => ({
        ...state,
        customTags: {
          ...state.customTags,
          tempFields,
        },
      }));
    },
    setSelectedFields: (selectedFields: ICKField[]) => {
      set((state) => ({
        ...state,
        customTags: { ...state.customTags, selectedFields },
      }));
    },

    storeKeySetter: (key: WordEditorStoreKeyType, value: any) => {
      set((state) => ({
        ...state,
        customTags: { ...state.customTags, [key]: value },
      }));
    },
    getKey: (key: WordEditorStoreKeyType) => {
      return get().customTags[key];
    },
  },
});
